var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from 'react';
import { createSignInMessage } from '@solana/wallet-standard-util';
import { appEnv } from '@cta-portal/webapp-common/lib/env';
import { useI18n } from '@cta-portal/webapp-common/src/hooks/translations/use-i18n';
import { useToggle } from '../../hooks/common/use-toogle';
import { isMobile } from '../../utils/common';
export function usePhantomContext(_a) {
    var _this = this;
    var setLoading = _a.setLoading, setLoadingText = _a.setLoadingText;
    var t = useI18n().t;
    var useLedgerSwitch = useToggle(false);
    var _b = useState(null), publicKey = _b[0], setPublicKey = _b[1];
    var _c = useState(null), walletAddress = _c[0], setWalletAddress = _c[1];
    var _d = useState(null), error = _d[0], setError = _d[1];
    var _e = useState(null), provider = _e[0], setProvider = _e[1];
    var _f = useState(null), redirectUri = _f[0], setRedirectUri = _f[1];
    useEffect(function () {
        var getProvider = function () {
            var _a;
            if ('phantom' in window) {
                var provider_1 = (_a = window === null || window === void 0 ? void 0 : window.phantom) === null || _a === void 0 ? void 0 : _a.solana;
                if (provider_1 === null || provider_1 === void 0 ? void 0 : provider_1.isPhantom) {
                    return provider_1;
                }
                return null;
            }
            return null;
        };
        setProvider(function (prev) { return prev !== null && prev !== void 0 ? prev : getProvider(); });
    }, []);
    // Listen for account changes
    useEffect(function () {
        if (provider) {
            provider.on('accountChanged', function (publicKey) {
                setPublicKey(publicKey ? publicKey : null);
                setWalletAddress(publicKey ? publicKey.toString() : null);
            });
        }
    }, [provider]);
    var connectWallet = function () { return __awaiter(_this, void 0, Promise, function () {
        var publicKey_1, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isMobile() && !(provider === null || provider === void 0 ? void 0 : provider.isPhantom)) {
                        setError(t('phantom.wallet-not-detected'));
                        return [2 /*return*/, null];
                    }
                    if (!(provider === null || provider === void 0 ? void 0 : provider.isPhantom)) {
                        // setError(t('phantom.wallet-not-detected'))
                        throw new Error(t('phantom.wallet-not-detected'));
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    setLoading(true);
                    setLoadingText(t('phantom.connect.loading-text'));
                    setError(null);
                    return [4 /*yield*/, provider.connect()];
                case 2:
                    publicKey_1 = (_a.sent()).publicKey;
                    setPublicKey(publicKey_1);
                    setWalletAddress(publicKey_1.toString());
                    return [2 /*return*/, {
                            address: publicKey_1.toString(),
                            publicKey: publicKey_1,
                        }];
                case 3:
                    err_1 = _a.sent();
                    setError(err_1 instanceof Error ? err_1.message : t('common.error'));
                    return [2 /*return*/, null];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var signMessage = function (message) { return __awaiter(_this, void 0, void 0, function () {
        var encoder, encodedMessage, signature;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(provider === null || provider === void 0 ? void 0 : provider.isPhantom) || !provider.signMessage)
                        throw new Error(t('phantom.sign-message.error'));
                    encoder = new TextEncoder();
                    encodedMessage = encoder.encode(message);
                    return [4 /*yield*/, provider.signMessage(encodedMessage, 'utf8')];
                case 1:
                    signature = (_a.sent()).signature;
                    return [2 /*return*/, signature];
            }
        });
    }); };
    var signIn = function (input, address, publicKey) { return __awaiter(_this, void 0, Promise, function () {
        var message, signature;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    message = createSignInMessage(__assign(__assign({}, input), { address: address }));
                    if (!(provider === null || provider === void 0 ? void 0 : provider.signMessage) || !publicKey) {
                        throw new Error(t('phantom.sign-message.error'));
                    }
                    return [4 /*yield*/, provider.signMessage(message)];
                case 1:
                    signature = (_a.sent()).signature;
                    return [2 /*return*/, {
                            account: {
                                publicKey: (publicKey === null || publicKey === void 0 ? void 0 : publicKey.toBytes()) || new Uint8Array(),
                                address: '',
                                chains: [],
                                features: [],
                            },
                            signedMessage: message,
                            signature: signature,
                            signatureType: 'ed25519',
                        }];
            }
        });
    }); };
    var handleSignIn = function (address, isLedger, publicKey) { return __awaiter(_this, void 0, void 0, function () {
        var signInData, output, backendOutput, loginResponse, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!signIn)
                        return [2 /*return*/];
                    if (isMobile() && !(provider === null || provider === void 0 ? void 0 : provider.isPhantom)) {
                        setError(t('phantom.wallet-not-detected'));
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    if (!(isLedger && provider)) return [3 /*break*/, 1];
                    handleLedgerSignIn();
                    return [3 /*break*/, 8];
                case 1: return [4 /*yield*/, fetch("".concat(appEnv.server.authUrl, "/auth/login/solana"), { method: 'GET', credentials: 'include' })];
                case 2: return [4 /*yield*/, (_a.sent()).json()];
                case 3:
                    signInData = _a.sent();
                    _a.label = 4;
                case 4:
                    _a.trys.push([4, 7, , 8]);
                    return [4 /*yield*/, signIn(signInData, address, publicKey)];
                case 5:
                    output = _a.sent();
                    if (!output)
                        throw new Error(t('phantom.sign-in.error'));
                    backendOutput = {
                        account: __assign(__assign({}, output.account), { publicKey: Array.from(output.account.publicKey) }),
                        signature: Array.from(output.signature),
                        signedMessage: Array.from(output.signedMessage),
                    };
                    return [4 /*yield*/, fetch("".concat(appEnv.server.authUrl, "/auth/login/solana"), {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify(backendOutput),
                            credentials: 'include',
                        })];
                case 6:
                    loginResponse = _a.sent();
                    if (loginResponse.ok && redirectUri) {
                        // await loginResponse.json()
                        globalThis.location.href = redirectUri;
                        // input.setLoading(false)
                    }
                    setLoading(false);
                    return [3 /*break*/, 8];
                case 7:
                    err_2 = _a.sent();
                    setError(err_2 instanceof Error ? err_2.message : t('common.error'));
                    setLoading(false);
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var handleLedgerSignIn = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/];
        });
    }); };
    return {
        walletAddress: walletAddress,
        connectWallet: connectWallet,
        signMessage: signMessage,
        error: error,
        signIn: signIn,
        handleSignIn: handleSignIn,
        provider: provider,
        useLedgerSwitch: useLedgerSwitch,
        publicKey: publicKey,
        setRedirectUri: setRedirectUri,
        redirectUri: redirectUri,
    };
}
